var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "conversation-list" } },
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c("a-input", {
            staticClass: "search-item",
            attrs: {
              placeholder: _vm.$t("message.search"),
              name: "search",
              autocomplete: "off",
            },
            model: {
              value: _vm.searchValue,
              callback: function ($$v) {
                _vm.searchValue = $$v
              },
              expression: "searchValue",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.filterDatas.length
        ? _c("NoMessage", { attrs: { desc: _vm.$t("message.noMessage") } })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filterDatas, function (data) {
        var _obj
        return _c(
          "div",
          {
            staticClass: "chat-item",
            class:
              ((_obj = {
                selected: _vm.$_.get(_vm.selectedChat, "_id") === data._id,
              }),
              (_obj[data.meta.chatType] = true),
              _obj),
          },
          [
            _c(
              "div",
              {
                staticClass: "chat-card",
                on: {
                  click: function ($event) {
                    return _vm.openConv(data)
                  },
                },
              },
              [
                _c("div", { staticClass: "second" }, [
                  _c(
                    "div",
                    { staticClass: "chat-avatar" },
                    [
                      _c("Avatar", {
                        staticClass: "AvatarOnChat",
                        attrs: {
                          size: 30,
                          username: _vm.getName(data.meta) || "",
                          src: _vm.getAgentImage(data),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "chat-content" }, [
                    _c("span", { staticClass: "chat-content-span" }, [
                      _c(
                        "div",
                        {
                          staticClass: "tooltip-container",
                          attrs: { title: _vm.getName(data.meta) },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.getName(data.meta)) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.typingMessageVisible(data)
                        ? _c("div", { staticClass: "typing-message" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.typingMessage(data) +
                                    " " +
                                    _vm.$t("message.typing_w_chat")
                                ) +
                                "\n                        "
                            ),
                          ])
                        : _c("div", [
                            _c("div", { staticClass: "message" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.messageText(_vm.getLastMessage(data))
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toolbarC" }, [
                    _c("div", { staticClass: "toolbar" }, [
                      _c("div", { staticClass: "right" }, [
                        _c("div", [
                          !_vm.isMute(data)
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "material-icons notification-volume",
                                },
                                [_vm._v("volume_off")]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          data.meta.chatType === "team" ||
                          (data.meta.chatType == "thread" &&
                            data.meta.thread.agent1._id ==
                              data.meta.thread.agent2._id)
                            ? _c(
                                "span",
                                { staticClass: "material-icons pinButton" },
                                [
                                  _vm._v(
                                    "push_pin\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm.infoVisibility
                              ? _c(
                                  "a-popover",
                                  {
                                    attrs: {
                                      id: "chat-detail",
                                      placement: "right",
                                      trigger: "click",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "material-icons btnMore",
                                        on: {
                                          click: function ($event) {
                                            _vm.selectedMoreChat = data
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        more_horiz"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm.nameUpdateCondition(data)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "chat-detail-item",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.moreChatVisible = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.edit_group_info"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isMute(data)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "chat-detail-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.notificationOpen(
                                                      data
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.notif_sound"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "button",
                                              {
                                                staticClass: "chat-detail-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.notificationClose(
                                                      data
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.notif_mute"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _vm.leaveChatCondition(data)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "chat-detail-item",
                                                on: { click: _vm.leaveGroup },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t("message.leave")
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.deleteChat(data)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "chat-detail-item",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.deleteModal = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t("chatbotv2.delete")
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.getUnreadMessageCount(data) > 0
                      ? _c("span", { staticClass: "unread-count" }, [
                          _vm._v(_vm._s(_vm.getUnreadMessageCount(data))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "left" }, [
                      _vm.isTeam(data)
                        ? _c("div", { staticClass: "type-tag" }, [
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-hour" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.messageDate(_vm.getLastMessage(data))
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-typeS team" }, [
                                _vm._v(_vm._s(_vm.$t("message.team"))),
                              ]),
                            ]),
                          ])
                        : _vm.isGroup(data)
                        ? _c("div", { staticClass: "type-tag" }, [
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-hour" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.messageDate(_vm.getLastMessage(data))
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-typeS group" }, [
                                _vm._v(" " + _vm._s(_vm.$t("message.group"))),
                              ]),
                            ]),
                          ])
                        : _vm.isDepartment(data)
                        ? _c("div", { staticClass: "type-tag" }, [
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-hour" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.messageDate(_vm.getLastMessage(data))
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c(
                                "span",
                                { staticClass: "span-typeS department" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("message.department"))
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm.isThreadPrivate(data)
                        ? _c("div", { staticClass: "type-tag" }, [
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-hour" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.messageDate(_vm.getLastMessage(data))
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-typeS note" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("userInfoWidget.note")) +
                                    " "
                                ),
                              ]),
                            ]),
                          ])
                        : _vm.isThread(data)
                        ? _c("div", { staticClass: "type-tag" }, [
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-hour" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.messageDate(_vm.getLastMessage(data))
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "type-tagTwo" }, [
                              _c("span", { staticClass: "span-typeS thread" }, [
                                _vm._v(_vm._s(_vm.$t("teamChatPanel.dmTag"))),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm.moreChatVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.set_group_info"),
                description: _vm.getName(_vm.selectedMoreChat.meta),
                id: "update-chat-info",
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.moreChatVisible = false
                },
              },
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.new_name")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newChatName,
                    expression: "newChatName",
                  },
                ],
                attrs: { id: "update-chat-name", type: "text" },
                domProps: { value: _vm.newChatName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newChatName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("a-button", { on: { click: _vm.GroupNameChange } }, [
                    _vm._v(" " + _vm._s(_vm.$t("message.save"))),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("teamChatPanel.deleteChatTitle"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteGroupThreadConversation },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("message.delChannel")))])]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }